import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { incidentSeverityColorOptions } from '../../screens/admin/admin-console/admin-console-content-pages/admin-console-incident-reporting/admin-console-incident-report-model';

interface ColourPickerSelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  id?: string;
}

const ColourPickerSelect = (props: ColourPickerSelectProps) => {
  const { value, onChange, label = 'Colour', id = 'colour-picker' } = props;

  return (
    <FormControl variant='outlined' style={{ minWidth: 120 }}>
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as string)}
        label={label}
        inputProps={{ name: 'colour', id }}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 56 }}
        renderValue={(val) => {
          const colourOption = incidentSeverityColorOptions.find((c) => c.hexValue === val);
          return (
            <Box display='flex' alignItems='center' style={{ gap: 8 }}>
              <Box style={{ width: 20, height: 20, borderRadius: '50%', backgroundColor: val as string }} />
              {colourOption?.name || ''}
            </Box>
          );
        }}
        MenuProps={{
          PaperProps: { style: { maxHeight: 300 } },
          anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
          transformOrigin: { vertical: 'top', horizontal: 'center' },
          getContentAnchorEl: null,
        }}
      >
        {incidentSeverityColorOptions.map((colour) => (
          <MenuItem key={colour.hexValue} value={colour.hexValue}>
            <Box display='flex' alignItems='center' style={{ gap: 10 }}>
              <Box
                style={{ width: 20, height: 20, borderRadius: '50%', backgroundColor: colour.hexValue, flexShrink: 0 }}
              />
              {colour.name}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export { ColourPickerSelect };
